import { jsx as _jsx } from "react/jsx-runtime";
import { router } from '@inertiajs/react';
import { debounce } from 'lodash';
import { useEffect, useState } from 'react';
import { CopyrightCheckerDossiersOverviewView } from './CopyrightCheckerOverview.view';
function Overview({ data: resData, availableStatuses = [], filters = {}, notice, }) {
    const [data, setData] = useState(resData?.data || []);
    const [filterState, setFilterState] = useState(filters);
    const [loading, setLoading] = useState(false);
    const [pageNumber, setPage] = useState(resData.current_page);
    useEffect(() => {
        router.on('start', () => {
            setLoading(true);
        });
        router.on('finish', () => {
            setLoading(false);
        });
    }, []);
    useEffect(() => {
        setData(resData?.data || []);
    }, [resData]);
    useEffect(() => {
        router.replace(location.pathname, {
            data: {
                page: pageNumber,
                filter: {
                    ignored: filterState.ignored,
                    status: filterState.status,
                    minimum_detections: filterState.minimum_detections,
                    domain: filterState.domain,
                },
            },
            only: ['dossiers', 'domains'],
        });
    }, [
        pageNumber,
        filterState.ignored,
        filterState.status,
        filterState.domain,
        filterState.minimum_detections,
    ]);
    const handleFilter = debounce((_filters) => {
        setFilterState(_filters);
    }, 300);
    return (_jsx(CopyrightCheckerDossiersOverviewView, { notice: notice, loading: loading, data: data, availableStatuses: availableStatuses, filterState: filterState, handleFilter: handleFilter, resData: resData, setPage: setPage }));
}
export default Overview;
